








import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WPage extends BaseComponent {
	@Prop(Boolean)
	fixed!: boolean;
}
